module.exports = __webpack_public_path__ + "img/u2535.764416ef.png";